import React from 'react';

import { PermissiblePurposes } from 'src/components/account';
import { DetailPageLayout } from 'src/components/common';
import { PermissiblePurposeCreateModal } from 'src/modals/pemissiblePurpose';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const VerificationPurposesPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Verification Purposes">
      <TableDataProvider>
        <PermissiblePurposes />
      </TableDataProvider>

      <PermissiblePurposeCreateModal />
    </DetailPageLayout>
  );
};
